export const CONTENT_TOOLS_QUERY_PARAMS = {
  tab: 'tab',
  questionLibrary: {
    view: 'qlView',
    mode: 'qlMode',
    radarDefinition: 'radarDefinition',
    questionId: 'qlQuestionId',
    courseId: 'qlCourseId',
    flowId: 'qlFlowId',
    questionType: 'qlQuestionType',
  },
  flowBuilder: {
    flowId: 'fbFlowId',
    courseId: 'fbCourseId',
    /** 'all' opens the All modules tab; absent opens By course. */
    mode: 'fbMode',
  },
  courseBuilder: {
    courseId: 'cbCourseId',
  },
} as const;

export type SearchParamValue = string | number | null | undefined;

export const normalizePositiveIntegerParam = (value: string | null): string | null => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }

  const parsed = Number(trimmed);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return null;
  }

  return String(parsed);
};

export const parsePositiveIntegerParam = (value: string | null): number | null => {
  const normalized = normalizePositiveIntegerParam(value);
  if (!normalized) {
    return null;
  }

  return Number(normalized);
};

export const updateContentToolsSearchParams = (
  searchParams: URLSearchParams,
  updates: Record<string, SearchParamValue>,
) => {
  const nextParams = new URLSearchParams(searchParams);

  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      nextParams.delete(key);
      return;
    }

    nextParams.set(key, String(value));
  });

  return nextParams;
};
